import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  inputWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: "360px",
  },
  input: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    height: "44px",
    width: "100%",
    color: colors.lightBlack,
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    boxShadow: `0px 1px 2px 0px ${colors.shadowLightGrey}`,
    "&:focus": {
      outline: "none"
    },
    "&::placeholder": {
      color: colors.inactiveGrey,
    }
  },
  icon: {
    position: "absolute",
    left: "16px",
    top: "8px"
  },
  spinner: {
    position: "absolute",
    left: "16px",
    top: "50%",
    marginLeft: 0,
    height: "20px",
    transform: "translate( 0%, -50%)"
  }
}));

export default styles;